import type { ReactNode } from "react";

import { ScrollArea } from "@mantine/core";
import { useState } from "react";

import { GradientHeader } from "@/panels/modules/panels/components/GradientHeader";

import classes from "./GuidedFlowsPanel.module.css";

interface GuidedFlowsPanelProps {
    guide: ReactNode;
}

export function GuidedFlowsPanel({ guide }: GuidedFlowsPanelProps) {
    return (
        <ScrollArea pos="absolute" inset={0} scrollbars="y" classNames={{ content: classes.content }}>
            {guide}
        </ScrollArea>
    );
}

interface InlineGuidedFlowsPanelProps {
    guide: ReactNode;
    title: string;
    onClose: () => void;
}

/** Stacks above the AI Assist timeline under its own header, sized to the guide and capped at half the parent. */
export function InlineGuidedFlowsPanel({ guide, title, onClose }: InlineGuidedFlowsPanelProps) {
    const [isMinimized, setIsMinimized] = useState(false);

    return (
        <>
            <GradientHeader
                title={title}
                onClose={onClose}
                onMinimize={() => setIsMinimized((minimized) => !minimized)}
                isMinimized={isMinimized}
            />
            {/* Hidden, not unmounted, so the guide keeps its answers. A style prop because Autosize sets an inline display. */}
            <ScrollArea.Autosize
                mah="50%"
                scrollbars="y"
                type="auto"
                display={isMinimized ? "none" : undefined}
                className={classes.inlineRoot}
            >
                {guide}
            </ScrollArea.Autosize>
        </>
    );
}
